<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules" :destroyOnClose="false">
        <a-form-model-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
          <a-input v-model="model.name" placeholder="请输入名称"></a-input>
        </a-form-model-item>

        <a-form-model-item label="类型 folder--file" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="type">
          <a-select v-model="model.type" placeholder="请选择" className="ant-form-item-control">
            <a-select-option key="folder" value="folder">folder</a-select-option>
            <a-select-option key="file" value="file">file</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="value" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="value">
          <a-input v-model="model.value" placeholder="请输入value"></a-input>
        </a-form-model-item>

        <a-form-model-item label="排序(值倒序)" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sort">
          <a-input v-model="model.sort" placeholder="请输入排序"></a-input>
        </a-form-model-item>

        <a-form-model-item label="业务类别" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="resourceCode">
          <a-select
            v-model="model.resourceCode"
            placeholder="请选择"
            @change="changeTag"
            className="ant-form-item-control"
          >
            <a-select-option v-for="(itemO, o) in resources" :key="o" :value="itemO.resourceCode">{{
              itemO.description
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="Auth" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="auth">
          <a-input v-model="model.auth" placeholder="请输入AUTH"></a-input>
        </a-form-model-item>
        <!-- 子表单区域 -->
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="标签列定义" key="1">
            <div>
              <a-row type="flex" style="margin-bottom: 5px" :gutter="16">
                <a-col :span="2">列名</a-col>
                <a-col :span="3">code</a-col>
                <a-col :span="2">tagCode</a-col>
                <a-col :span="5">属性值</a-col>
              </a-row>
              <a-row type="flex" :gutter="16" v-for="(item, index) in model.properties" :key="index">
                <a-col :span="2">
                  <a-form-model-item>
                    <p>{{ item.name }}</p>
                  </a-form-model-item>
                </a-col>
                <a-col :span="3">
                  <a-form-model-item>
                    <p>{{ item.code }}</p>
                  </a-form-model-item>
                </a-col>
                <a-col :span="2">
                  <a-form-model-item>
                    <p>{{ item.tagCode }}</p>
                  </a-form-model-item>
                </a-col>
                <!-- 952968087063502848 文本框 -->
                <a-col :span="5" v-show="item.controlType === '952968087063502848'">
                  <a-form-model-item
                    :prop="'properties.' + index + '.value'"
                    :rules="[{ required: item.required, trigger: 'blur', message: '请输入属性值!' }]"
                  >
                    <a-input placeholder="请输入属性值" v-model="item.value" />
                  </a-form-model-item>
                </a-col>
                <!-- 952968299416920064 下拉框 -->
                <a-col :span="5" v-show="item.controlType === '952968299416920064'">
                  <a-form-model-item
                    :prop="'properties.' + index + '.value'"
                    :rules="[{ required: item.required, trigger: 'blur', message: '请输入属性值!' }]"
                  >
                    <a-select v-model="item.value" placeholder="请选择">
                      <a-select-option v-for="itemO in item.resources" :key="itemO.id" :value="itemO.id">{{
                        itemO.name
                      }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <!-- 974317768837722112 树形下拉框 -->
                <a-col :span="5" v-show="item.controlType === '974317768837722112'">
                  <a-form-model-item
                    :prop="'properties.' + index + '.value'"
                    :rules="[{ required: item.required, trigger: 'blur', message: '请输入属性值!' }]"
                  >
                    <j-tree-select
                      v-model="item.value"
                      dict="do_form_core_resource,name,id"
                      pid-field="pid"
                      :pidValue="item.resourceId"
                    >
                    </j-tree-select>
                  </a-form-model-item>
                </a-col>
                <!-- 959772426476384256 textarea -->
                <a-col :span="5" v-show="item.controlType === '959772426476384256'">
                  <a-form-model-item
                    :prop="'properties.' + index + '.value'"
                    :rules="[{ required: item.required, trigger: 'blur', message: '请输入属性值!' }]"
                  >
                    <j-input-pop
                      v-model="item.value"
                      placeholder="请输入属性值"
                      :width="600"
                      :height="400"
                    ></j-input-pop>
                  </a-form-model-item>
                </a-col>
                <!-- 951885273278558208 文件上传 -->
                <a-col :span="5" v-show="item.controlType === '951885273278558208'">
                  <a-form-model-item
                    :prop="'properties.' + index + '.value'"
                    :rules="[{ required: item.required, trigger: 'blur', message: '请输入属性值!' }]"
                  >
                    <d-upload v-model="item.value" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import { getResourcePropsByPid, doMistServerUrl } from '@/api/api'
export default {
  name: 'DoFormCoreResourceModal',
  components: {},
  data() {
    return {
      title: '操作',
      width: 1440,
      visible: false,
      model: {
        properties: [],
        resourceCode: 'root'
      },
      modelDefault: {
        properties: [],
        resourceCode: 'root'
      },
      resources: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },

      confirmLoading: false,
      validatorRules: {
        name: [{ required: true, message: '请输入名称!' }],
        type: [{ required: true, message: '请输入类型 folder--file!' }],
        resourceCode: [{ required: true, message: '请选择标签库!' }],
        value: [{ required: false }]
      },
      url: {
        add: `${doMistServerUrl}/mistResource/saveResource`,
        edit: `${doMistServerUrl}/mistResource/updateResourceById`,
        getColumn: `${doMistServerUrl}/tagColumn/getColumnsByResourceCode`,
        getResources: `${doMistServerUrl}/tag/getResourceCode`,
        getResourceProps: `${doMistServerUrl}/resource/getResourceProps`
      },
      expandedRowKeys: [],
      pidField: 'pid'
    }
  },
  created() {
    // 备份model原始值
    getAction(this.url.getResources).then((res) => {
      let result = res.result
      this.resources = Object.assign({}, result)
    })
  },
  methods: {
    add(obj) {
      this.model = {
        ...this.modelDefault,
        ...obj
      }
      this.visible = true
    },
    async edit(record) {
      console.log('record', record)
      if (record.id) {
        // 编辑的时候显示所有的标签库column
        if (record.resourceCode) {
          await this.changeTag(record.resourceCode, record)
        } else {
          getAction(this.url.getResourceProps, { resourceId: record.id }).then((res) => {
            let result = res.result
            if (result) {
              result = result.map((t) =>
                Object.assign(t, {
                  write_visible: !!(!t.displayName && typeof t.displayName !== 'undefined' && t.displayName != 0),
                  choose_visible: !(!t.displayName && typeof t.displayName !== 'undefined' && t.displayName != 0)
                })
              )
              this.callgetResourcePropsByPid(result)

              this.model = Object.assign({}, record, { properties: result })
            }
          })
        }
      }

      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.$refs.form.clearValidate()
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            // 新增
            httpurl += this.url.add
            method = 'post'
            let property = {}
            for (let i = 0; i < this.model.properties.length; i++) {
              property[this.model.properties[i]['code']] = this.model.properties[i]['value']
            }
            this.model = Object.assign(this.model, { properties: property })
          } else {
            httpurl += this.url.edit
            method = 'post'
            let property = {}
            if (this.model.properties) {
              for (let i = 0; i < this.model.properties.length; i++) {
                property[this.model.properties[i]['code']] = this.model.properties[i]['value']
              }
            }

            this.model = Object.assign(this.model, { properties: property })
          }
          if (this.model[this.pidField] !== '0') {
            // 有父节点,点击的是添加下级
            getAction(this.url.getResourceProps, { resourceId: this.model[this.pidField] }).then((res) => {
              // 得到所有的column属性
              if (res.success) {
                let result = {}

                for (let i = 0; i < res.result.length; i++) {
                  result[res.result[i]['code']] = res.result[i]['value']
                }
                let httpurl2 = this.url.edit
                let method2 = 'post'
                httpAction(
                  httpurl2,
                  { id: this.model[this.pidField], hasChild: '1', properties: result },
                  method2
                ).then((res) => {
                  if (res.success) {
                    this.$emit('ok')
                  } else {
                    that.$message.warning(res.message)
                  }
                })
              } else {
                this.$message.warning(res.message)
              }
            })
          }

          httpAction(httpurl, this.model, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                this.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.close()
    },
    submitSuccess(formData, flag) {
      if (!formData.id) {
        let treeData = this.$refs.treeSelect.getCurrTreeData()
        this.expandedRowKeys = []
        this.getExpandKeysByPid(formData[this.pidField], treeData, treeData)
        this.$emit('ok', formData, this.expandedRowKeys.reverse())
      } else {
        this.$emit('ok', formData, flag)
      }
    },
    getExpandKeysByPid(pid, arr, all) {
      if (pid && arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].key == pid) {
            this.expandedRowKeys.push(arr[i].key)
            this.getExpandKeysByPid(arr[i]['parentId'], all, all)
          } else {
            this.getExpandKeysByPid(pid, arr[i].children, all)
          }
        }
      }
    },
    async changeTag(value, record) {
      let res = await getAction(this.url.getColumn, { resourceCode: value })
      const result = res.result
      await this.callgetResourcePropsByPid(result)

      const resourceId = record && record.id ? record.id : this.model.id
      // 如果是新增,没有resourceid,不需要
      if (resourceId) {
        res = await getAction(this.url.getResourceProps, { resourceId })

        if (res.result) {
          result.forEach((p) => {
            const propValue = res.result.find((r) => r.code === p.code)
            p.value = propValue ? propValue.value : ''
          })
        }
      }
      this.model = {
        ...(record && record.id ? record : this.model),
        resourceCode: value,
        properties: result
      }
    },
    async callgetResourcePropsByPid(result) {
      for (let i = 0; i < result.length; i++) {
        if (
          result[i]['resourceId'] !== '' &&
          !(!result[i]['resourceId'] && typeof result[i]['resourceId'] !== 'undefined' && result[i]['resourceId'] != 0)
        ) {
          await getResourcePropsByPid({ resourceId: result[i]['resourceId'] }).then((res) => {
            if (res.success) {
              Object.assign(result[i], { resources: res.result })
              this.$forceUpdate()
            }
          })
        }
      }
    }
  }
}
</script>
